import { AppModal } from '@/layout/AppComponents';
import Translator from '@/layout/components/helpers/Translator';
import { path } from '@/routing/helpers/router';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function ModalWarning({ modalWarning }) {
  const { moduleBridgeHex } = useParams();
  const navigate = useNavigate();

  return modalWarning ? (
    <AppModal
      show={modalWarning}
      isConfirmBtn
      confirmBtnText={<Translator file="user" name="user.accept" />}
      onConfirm={() =>
        navigate(
            path({
              name: 'user_module_dynamicForm_home',
              params: { moduleBridgeHex },
            })
        )
      }
      onClose={() =>
        navigate(
            path({
              name: 'user_module_dynamicForm_home',
              params: { moduleBridgeHex },
            })
        )
      }
    >
      {modalWarning}
    </AppModal>
  ) : null;
}
